module.exports = __webpack_public_path__ + "img/image26.05371494.jpeg";